import React, { useState } from "react";
import styled from "styled-components";

import CalenderIcon from '../../../Image/GrayCalenderIcon.png';
import DateSelectModal from "../../Main/Model/DateSelectModal";

import TimeInput from "../../Main/Component/TimeInput";

export default function WodDateBox(props) {
  const { 
    isEdit,
    startDate, 
    setStartDate, 
    startTime,
    setStartTime,
    endDate, 
    setEndDate,
    endTime,
    setEndTime
  } = props;

  const [isClickedModifyDate, setIsClickedModifyDate] = useState(false);

  // 시작일 버튼 클릭시 //
  function onClickModifyDateButton() {
    if (!isEdit) return;

    setIsClickedModifyDate(true);
  }

  return (
    <TopLevelWrapper>
      { isClickedModifyDate && <DateSelectModal startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} close={() => setIsClickedModifyDate(false)}/> }
      <ColumnBox>
        <Text fontFamily='NotoSansKR-Black' fontSize={14} color='#2F2F32' cursor='default'>이벤트 오픈, 기록 시간</Text>
      </ColumnBox>
      <ViewBox>
        <DateComponentWrapper>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='default'>시작일</Text>
          <DateButton onClick={onClickModifyDateButton} border={isEdit ? '2px dashed #909090' : '2px solid #909090'} cursor={isEdit ? 'pointer' : 'default'}>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor={isEdit ? 'pointer' : 'default'}>{startDate.format('YYYY.MM.DD')}</Text>
            <CalenderImage src={CalenderIcon} />
          </DateButton>
          <TimeInput isEdit={isEdit} value={startTime} setValue={setStartTime} placeholder='00:00' />
        </DateComponentWrapper>
        <Text fontFamily='NotoSansKR-Medium' fontSize={20} color='#FFFFFF' cursor='default'>~</Text>
        <DateComponentWrapper>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='default'>종료일</Text>
          <DateButton onClick={onClickModifyDateButton} border={isEdit ? '2px dashed #909090' : '2px solid #909090'} cursor={isEdit ? 'pointer' : 'default'}>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor={isEdit ? 'pointer' : 'default'}>{endDate.format('YYYY.MM.DD')}</Text>
            <CalenderImage src={CalenderIcon} />
          </DateButton>
          <TimeInput isEdit={isEdit} value={endTime} setValue={setEndTime} placeholder='00:00' />
        </DateComponentWrapper>
      </ViewBox>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const ColumnBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 5px 10px;
  
  border-radius: 5px 5px 0px 0px;
  background-color: #6DD49E;
`;

const ViewBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 15px 15px 20px 15px;

  width: calc(100% - 30px);

  border-radius: 0px 10px 10px 10px;
  background-color: #17171B;
`;

// const TopLevelWrapper = styled.div`
//   display: flex;
//   flex-direction: row;
//   flex-wrap: wrap;

//   justify-content: space-between;
//   align-items: center;

//   width: 100%;
// `;

const DateComponentWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  gap: 4px;
`;

const DateButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 131px;
  height: 28px;

  gap: 8px;

  border: ${props => props.border};
  border-radius: 8px;
  background-color: #2F2F32;

  :hover {
    cursor: ${props => props.cursor};
  }
`;

const CalenderImage = styled.img`
  width: 18px;
  height: 18px;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
  
  :hover {
    cursor: ${props => props.hover};
  }

  transition: all 0.3s ease-in-out;
`;